// In production, we register a service worker to serve assets from local cache.

// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.

// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.

const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.1/8 is considered localhost for IPv4.
  window.location.hostname.match(
    /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
  )
);

export default function register (updateCallback ,readyCallback) {
  console.log("Worker: ENV=" + process.env.NODE_ENV);
  console.log("Worker: Update callback=" + updateCallback);

  if (process.env.NODE_ENV === 'production' && 'serviceWorker' in navigator) {
    // The URL constructor is available in all browsers that support SW.
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location);
    if (publicUrl.origin !== window.location.origin) {
      // Our service worker won't work if PUBLIC_URL is on a different origin
      // from what our page is served on. This might happen if a CDN is used to
      // serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
      return;
    }

    window.addEventListener('load', () => {
      console.log("Worker: load");
      const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

      if (isLocalhost) {
        // This is running on localhost. Lets check if a service worker still exists or not.
        checkValidServiceWorker(swUrl);
      } else {
        // Is not local host. Just register service worker
        registerValidSW(swUrl, updateCallback, readyCallback);
      }
    });
  }
}

function registerValidSW (swUrl, updateCallback, readyCallback) {
  console.log("Worker: registerValidSW");
  console.log("Worker swUrl: " + swUrl);

  navigator.serviceWorker
    .register(swUrl)
    .then(registration => {
      registration.onupdatefound = () => {
        console.log("Worker: Update found");
        const installingWorker = registration.installing;
        installingWorker.onstatechange = () => {
          console.log("Worker: State updated");
          console.log("Worker: State=" + installingWorker.state);
          if (installingWorker.state === 'installed') {
            if (navigator.serviceWorker.controller) {
              // At this point, the old content will have been purged and
              // the fresh content will have been added to the cache.
              // It's the perfect time to display a "New content is
              // available; please refresh." message in your web app.
              console.log('Worker: New content is available; please refresh.');
              if(updateCallback)
                updateCallback(true);
            } else {
              // At this point, everything has been precached.
              // It's the perfect time to display a
              // "Content is cached for offline use." message.
              console.log('Worker: Content is cached for offline use.');
              if(updateCallback)
                updateCallback(false);
            }
          }
        };
      };

    })
    .catch(error => {
      console.error('Error during service worker registration:', error);
    });

    let refreshing;
    navigator.serviceWorker.oncontrollerchange = () => {
      console.log("Worker: Controller change");
      if(refreshing) return;

      console.log("Worker: Controller change: reloading");
      window.location.reload();
      refreshing = true;

      console.log("Worker: Controller change: done.");
    };

    navigator.serviceWorker.ready.then((registration) => {
      console.log("Worker ready");
      console.log("Scope: " + registration.scope);
      
      
      if(readyCallback)
        readyCallback();
    });

    navigator.serviceWorker.onmessage = (event) =>
    {
      console.log("Worker: message received");
      console.log(event);
    };
}

function checkValidServiceWorker (swUrl) {
  // Check if the service worker can be found. If it can't reload the page.
  fetch(swUrl)
    .then(response => {
      // Ensure service worker exists, and that we really are getting a JS file.
      if (
        response.status === 404 ||
        response.headers.get('content-type').indexOf('javascript') === -1
      ) {
        // No service worker found. Probably a different app. Reload the page.
        navigator.serviceWorker.ready.then(registration => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        // Service worker found. Proceed as normal.
        registerValidSW(swUrl);
      }
    })
    .catch(() => {
      console.log(
        'No internet connection found. App is running in offline mode.'
      );
    });
}

export function unregister () {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready.then(registration => {
      registration.unregister();
    });
  }
}
